import type { FieldErrors } from '@/types'

export class ApiError extends Error {
    status: number
    fieldErrors: FieldErrors

    constructor(message: string, status: number, fieldErrors: FieldErrors = {}) {
        super(message)
        this.name = 'ApiError'
        this.status = status
        this.fieldErrors = fieldErrors
    }
}

type RequestOptions = {
    method?: 'GET' | 'POST' | 'PUT' | 'DELETE'
    body?: unknown
}

export const apiRequest = async <T>(path: string, { method = 'GET', body }: RequestOptions = {}): Promise<T> => {
    let response: Response

    try {
        response = await fetch(path, {
            method,
            headers: body === undefined ? undefined : { 'Content-Type': 'application/json' },
            body: body === undefined ? undefined : JSON.stringify(body)
        })
    }
    catch {
        throw new ApiError('No se pudo conectar. Revisa tu conexión e inténtalo de nuevo.', 0)
    }

    const data = await response.json().catch(() => null) as { message?: string, fieldErrors?: FieldErrors } | null

    if (!response.ok) {
        throw new ApiError(
            data?.message || 'Algo salió mal. Inténtalo de nuevo.',
            response.status,
            data?.fieldErrors ?? {}
        )
    }

    return data as T
}

export const getErrorMessage = (error: unknown): string => {
    if (error instanceof ApiError) return error.message

    return 'Algo salió mal. Inténtalo de nuevo.'
}
